export const productsData = [
  // BEDS first
  {
    id: 'nova-5500',
    name: 'Nova-5500 Full Body Red Light + NIR Therapy Bed',
    badge: 'Best Seller',
    image: 'https://static.wixstatic.com/media/b85534_275c49b8698d44d2918543cdf35026c2~mv2.jpg/v1/fill/w_513,h_297,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/b85534_275c49b8698d44d2918543cdf35026c2~mv2.jpg',
    category: 'Therapy Beds',
    description: 'The Nova-5500 represents the pinnacle of full-body red light and near-infrared therapy technology. This advanced therapy bed delivers comprehensive treatment for both commercial and residential applications.',
    features: [
      'Full-body coverage with optimal wavelength distribution',
      'Dual wavelength technology: 660nm red light + 850nm near-infrared',
      'Smart control system with customizable treatment protocols',
      'Professional-grade LED arrays with extended lifespan',
      'Ergonomic design for maximum comfort during sessions',
      'Advanced cooling system for consistent performance'
    ],
    specifications: {
      'Wavelengths': '633nm / 660nm / 810nm / 850nm / 940nm',
      'Total LED Count': '43,200 LEDs',
      'Nominal System Power': '6000W',
      'Maximum Irradiance': 'Up to 129 mW/cm²',
      'Electrical Requirements': '100–240V / 50–60Hz',
      'Control System': 'LCD control system',
      'Dimensions': '2300 × 1260 × 1134 mm',
      'Weight': '490 kg',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '3-Year Warranty on Major Components'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nova-r5200',
    name: 'Nova-R5200 Advanced Commercial Red Light + NIR Therapy Bed',
    image: 'https://static.wixstatic.com/media/b85534_dee6ff3a014b4cec8f807f79cc46643d~mv2.jpg/v1/fill/w_512,h_294,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/b85534_dee6ff3a014b4cec8f807f79cc46643d~mv2.jpg',
    category: 'Therapy Beds',
    description: 'Designed for high-volume commercial environments, the Nova-R5200 delivers professional-grade therapy with advanced features and exceptional durability.',
    features: [
      'Commercial-grade construction for intensive use',
      'Advanced multi-wavelength LED technology',
      'Programmable treatment protocols',
      'Enhanced power output for faster results',
      'Durable materials built for daily operation',
      'Comprehensive safety features'
    ],
    specifications: {
      'Wavelengths': '630nm, 660nm, 810nm, 850nm',
      'Control System': 'Advanced Digital Interface',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '3-Year Warranty on Major Components'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nova-r1160',
    name: 'Nova-R1160 Compact Red Light + NIR Therapy Bed',
    image: 'https://static.wixstatic.com/media/b85534_776251e09e7f4ce5a93b76670fafb03b~mv2.jpg/v1/fill/w_510,h_286,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/b85534_776251e09e7f4ce5a93b76670fafb03b~mv2.jpg',
    category: 'Therapy Beds',
    description: 'The Nova-R1160 offers professional therapy bed performance in a space-efficient design, perfect for smaller facilities or home use.',
    features: [
      'Compact footprint without compromising coverage',
      'Professional-grade LED technology',
      'User-friendly control interface',
      'Efficient power consumption',
      'Easy setup and maintenance',
      'Quiet operation'
    ],
    specifications: {
      'Wavelengths': '633nm / 660nm / 850nm / 940nm',
      'Total LED Count': '13,680 LEDs',
      'Control System': 'LCD control system',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '3-Year Warranty on Major Components'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  // PANELS (descending power) - with stands first, then without
  {
    id: 'nr-6000a-stand',
    name: 'NR-6000A Ultra High Power Red Light Therapy Panel W/Stand',
    image: 'https://static.wixstatic.com/media/b85534_d1357a4e11c445859cdbfbb680749608~mv2.jpg/v1/fill/w_260,h_260,al_c,lg_1,q_80,enc_avif,quality_auto/b85534_d1357a4e11c445859cdbfbb680749608~mv2.jpg',
    category: 'Panels with Stand',
    description: 'Our most powerful panel system with professional stand, delivering maximum therapeutic benefits for serious users and commercial applications.',
    features: [
      'Ultra-high power LED array',
      'Adjustable professional stand included',
      'Multi-wavelength technology',
      'Large treatment area',
      'Advanced heat management',
      'Programmable timer settings'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'LED Count': '600+ LEDs',
      'Power Output': '6000W equivalent',
      'Coverage Area': 'Extra Large',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '2-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nr-6000a',
    name: 'NR-6000A Ultra High Power Red Light Therapy Panel',
    image: 'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/c1547c2241ced149d5b4b5a410b1fb88.webp',
    category: 'Panels',
    description: 'Maximum power in a wall-mountable or portable panel design. Perfect for dedicated therapy spaces.',
    features: [
      'Ultra-high LED density',
      'Wall-mountable or portable',
      'Dual wavelength output',
      'Maximum irradiance',
      'Built-in timer',
      'Low EMF design'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'LED Count': '600+ LEDs',
      'Power Output': '6000W equivalent',
      'Coverage Area': 'Extra Large',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '2-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nr-3000a-stand',
    name: 'NR-3000A Professional Red Light Therapy Panel w/Stand',
    image: 'https://static.wixstatic.com/media/b85534_cf4a7564e5d048b19930699e539fe289~mv2.jpg/v1/fill/w_260,h_260,al_c,lg_1,q_80,enc_avif,quality_auto/b85534_cf4a7564e5d048b19930699e539fe289~mv2.jpg',
    category: 'Panels with Stand',
    description: 'Professional-grade panel with stand, offering excellent power and coverage for both commercial and serious home users.',
    features: [
      'Professional power output',
      'Height-adjustable stand',
      'Dual wavelength LEDs',
      'Large coverage area',
      'Digital timer control',
      'Efficient cooling system'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'LED Count': '300+ LEDs',
      'Power Output': '3000W equivalent',
      'Coverage Area': 'Large',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '2-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nr-3000a',
    name: 'NR-3000A Professional Red Light Therapy Panel',
    image: 'https://static.readdy.ai/image/367285e2b2d60231336448d5a09f3ee9/e162869f799f783b7c68efd483da7fab.jpeg',
    category: 'Panels',
    description: 'Professional-grade panel offering excellent therapeutic power in a versatile, space-efficient design.',
    features: [
      'Professional LED array',
      'Versatile mounting options',
      'Dual wavelength therapy',
      'Optimal power density',
      'Digital controls',
      'Durable construction'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'LED Count': '300+ LEDs',
      'Power Output': '3000W equivalent',
      'Coverage Area': 'Large',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '2-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nr-1500a',
    name: 'NR-1500A High Output Red Light Therapy Panel',
    image: 'https://i.ibb.co/XxCMHhhH/1500-01.png',
    images: [
      'https://i.ibb.co/XxCMHhhH/1500-01.png',
      'https://i.ibb.co/gM5C0GbZ/1500-02.png',
      'https://i.ibb.co/5WvQFQLx/1500-03.png',
      'https://i.ibb.co/3wc3q2H/1500-04.png',
      'https://i.ibb.co/4R8RWd4X/1500-05.png'
    ],
    category: 'Panels',
    description: 'High-output panel perfect for serious home users and small professional practices seeking powerful therapy.',
    features: [
      'High-density LED array',
      'Compact yet powerful',
      'Dual wavelength output',
      'Easy to position',
      'Timer function',
      'Energy efficient'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'LED Count': '150+ LEDs',
      'Power Output': '1500W equivalent',
      'Coverage Area': 'Medium',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '2-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nr-1000a',
    name: 'NR-1000A Mid-Power Red Light Therapy Panel',
    image: 'https://i.ibb.co/LDRSGq6L/1000-08.png',
    images: [
      'https://i.ibb.co/LDRSGq6L/1000-08.png',
      'https://i.ibb.co/TDdStzKh/1000-07.png',
      'https://i.ibb.co/qM8rcVJp/1000-06.png',
      'https://i.ibb.co/yF171yCK/1000-05.png',
      'https://i.ibb.co/5W0T89xn/1000-04.png',
      'https://i.ibb.co/7NyM8ryW/1000-03.png',
      'https://i.ibb.co/KzB51nP3/1000-02.png',
      'https://i.ibb.co/C5vnXnfn/1000-01.png'
    ],
    category: 'Panels',
    description: 'Balanced power and portability make this panel ideal for consistent home therapy and wellness routines.',
    features: [
      'Optimal power balance',
      'Lightweight and portable',
      'Dual wavelength LEDs',
      'User-friendly controls',
      'Versatile placement',
      'Reliable performance'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'LED Count': '100+ LEDs',
      'Power Output': '1000W equivalent',
      'Coverage Area': 'Medium',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '2-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nr-600a',
    name: 'NR-600A Portable Red Light Therapy Panel',
    image: 'https://i.ibb.co/8gmjQsHR/600-01.png',
    images: [
      'https://i.ibb.co/8gmjQsHR/600-01.png',
      'https://i.ibb.co/GQVFBgVK/600-02.png',
      'https://i.ibb.co/XkdzHV9C/600-03.png',
      'https://i.ibb.co/SXQQZgF9/600-04.png',
      'https://i.ibb.co/kVMTthcx/600-05.png'
    ],
    category: 'Panels',
    description: 'Portable panel designed for flexible therapy sessions, perfect for targeted treatment and on-the-go use.',
    features: [
      'Portable design',
      'Targeted treatment',
      'Dual wavelength',
      'Easy to use',
      'Lightweight',
      'Versatile positioning'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'LED Count': '60+ LEDs',
      'Power Output': '600W equivalent',
      'Coverage Area': 'Small/Medium',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '2-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nr-400a',
    name: 'NR-400A Targeted Red Light Therapy Panel',
    image: 'https://i.ibb.co/nMx53V90/400-09.png',
    images: [
      'https://i.ibb.co/nMx53V90/400-09.png',
      'https://i.ibb.co/HDKbyQdS/400-08.png',
      'https://i.ibb.co/qYGLMzNy/400-07.png',
      'https://i.ibb.co/Jwch3gTg/400-06.png',
      'https://i.ibb.co/N6tdQGsr/400-05.png',
      'https://i.ibb.co/9mTxvRds/400-04.png',
      'https://i.ibb.co/BV9MXkr3/400-03.png',
      'https://i.ibb.co/BVN75srC/400-02.png',
      'https://i.ibb.co/rDRyF41/400-01.png'
    ],
    category: 'Panels',
    description: 'Compact panel designed for targeted treatment of specific areas, perfect for focused therapy sessions.',
    features: [
      'Compact design',
      'Targeted treatment',
      'Dual wavelength',
      'Easy to use',
      'Portable',
      'Affordable entry point'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'LED Count': '40+ LEDs',
      'Power Output': '400W equivalent',
      'Coverage Area': 'Small/Targeted',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '1-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nr-300a',
    name: 'NR-300A Portable Red Light Therapy Panel',
    image: 'https://i.ibb.co/FqXGJVc3/300-07.png',
    images: [
      'https://i.ibb.co/FqXGJVc3/300-07.png',
      'https://i.ibb.co/S257ZM1/300-06.png',
      'https://i.ibb.co/B2sWjxwt/300-05.png',
      'https://i.ibb.co/GfMZPXpW/300-04.png',
      'https://i.ibb.co/GQmQTN2g/300-03.png',
      'https://i.ibb.co/fYxW4Nsc/300-02.png',
      'https://i.ibb.co/NdcF38SD/300-01.png'
    ],
    category: 'Panels',
    description: 'Ultra-portable panel perfect for on-the-go therapy, travel, or as an introduction to red light therapy.',
    features: [
      'Ultra-portable design',
      'Lightweight construction',
      'Dual wavelength',
      'Simple operation',
      'Travel-friendly',
      'Great starter option'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'LED Count': '30+ LEDs',
      'Power Output': '300W equivalent',
      'Coverage Area': 'Small',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '1-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  // MASKS
  {
    id: 'nr-led-mask',
    name: 'NR LED Facial Therapy Mask',
    image: 'https://static.wixstatic.com/media/b85534_b460b807bd5b42f5aeda21f236b6cd3a~mv2.jpg/v1/fill/w_260,h_260,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/b85534_b460b807bd5b42f5aeda21f236b6cd3a~mv2.jpg',
    category: 'Facial Therapy',
    description: 'Advanced LED facial mask delivering professional-grade skin therapy in the comfort of your home for radiant, youthful skin.',
    features: [
      'Full-face LED coverage',
      'Multiple wavelength options',
      'Comfortable fit',
      'Hands-free operation',
      'Professional results at home',
      'Easy to clean'
    ],
    specifications: {
      'Wavelengths': '630nm, 660nm (Red Light)',
      'LED Count': '100+ LEDs',
      'Treatment Area': 'Full Face',
      'Session Time': '10-20 minutes',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '1-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  // ACCESSORIES (therapy mats)
  {
    id: 'nr-hg08',
    name: 'NR-HG08 Double Sided Red Light Therapy Mat',
    image: 'https://static.wixstatic.com/media/b85534_93afc0b521fb4783a4954332ab34d827~mv2.jpg/v1/fill/w_260,h_260,al_c,lg_1,q_80,enc_avif,quality_auto/b85534_93afc0b521fb4783a4954332ab34d827~mv2.jpg',
    category: 'Therapy Mats',
    description: 'Double-sided therapy mat providing comprehensive coverage for lying or sitting therapy sessions with maximum comfort.',
    features: [
      'Double-sided LED coverage',
      'Flexible mat design',
      'Full-body treatment capability',
      'Comfortable therapy sessions',
      'Easy storage',
      'Versatile positioning'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'Configuration': 'Double-Sided',
      'Coverage': 'Full Body',
      'Material': 'Medical-Grade Flexible',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '2-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  },
  {
    id: 'nr-hg07',
    name: 'NR-HG07 Single Sided Red Light Therapy Mat',
    image: 'https://static.wixstatic.com/media/b85534_211af0b3e67d4de8886fecc75c9f39bb~mv2.jpg/v1/fill/w_167,h_167,al_c,lg_1,q_80,enc_avif,quality_auto/b85534_211af0b3e67d4de8886fecc75c9f39bb~mv2.jpg',
    category: 'Therapy Mats',
    description: 'Single-sided therapy mat offering targeted treatment in a comfortable, flexible format for various therapy positions.',
    features: [
      'Single-sided LED array',
      'Flexible positioning',
      'Comfortable material',
      'Easy to use',
      'Portable design',
      'Effective coverage'
    ],
    specifications: {
      'Wavelengths': '660nm + 850nm',
      'Configuration': 'Single-Sided',
      'Coverage': 'Targeted/Full Body',
      'Material': 'Medical-Grade Flexible',
      'Certification': 'ISO 13485, CE, FCC, RoHS',
      'Warranty': '2-Year Warranty'
    },
    applications: [
      'Physical therapy clinics',
      'Orthopedic & sports medicine practices',
      'Performance & strength facilities',
      'Recovery studios',
      'Multi-room wellness operators',
      'Professional home therapy rooms'
    ]
  }
];